import {atom} from 'jotai';

export const browserCapabilitiesState = atom<{directUpload: boolean}>({
  directUpload: false,
});
